import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';

import { ReactNode } from 'react';
import { IMap, MapWidgetsProps } from 'common/utils/Map/types/map';
import { MapMarkerLayer } from 'common/utils/MapMarker';
import {
  Params as RouteConstructorParams
} from 'common/utils';

import { Controls } from './Controls';

import useMapStyles from './hooks/useMapStyles';
import useGlobalStyles from './useGlobalStyles';
import {
  useInitMap,
  useUpdateFocusPoint,
  useMapMarkerLayers,
  useUpdateMapWidgets
} from './hooks';
import {
  useShowStreetView,
  useMapOperations
} from 'entities/map';

import { useMapContext } from 'entities/map';

import useStyles from './useStyles';
export interface Props {
  showZoomControl?: boolean;
  onInitializedMap?: (map: IMap) => void;
  routeInitData?: RouteConstructorParams;
  styles?: React.CSSProperties;
  layers?: MapMarkerLayer[];
  widgets?: MapWidgetsProps[];
  controlComponents?: (props: { mapControls: ReactNode }) => ReactNode;
};

export interface MapProps extends Props {}

const Map = ({
  showZoomControl = true,
  styles,
  onInitializedMap,
  layers,
  widgets,
  controlComponents
}: Props) => {
  const { setShowStreetView } = useMapOperations();

  const showStreetView = useShowStreetView();
  const classes = useStyles({ showStreetView });
  const containerRef = useRef<HTMLDivElement>(null);
  const mapStyles = useMapStyles(styles);

  useInitMap(containerRef, onInitializedMap);
  useMapMarkerLayers(layers);
  useUpdateFocusPoint();
  useUpdateMapWidgets(widgets);
  useGlobalStyles();

  const { addListenerStreetViewChange, map } = useMapContext();

  useEffect(() => {
    addListenerStreetViewChange(setShowStreetView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  return (
    <>
      <Controls
        showZoomControl={showZoomControl}
        controlComponents={controlComponents}
      />
      <div
        id="map"
        ref={containerRef}
        style={mapStyles}
        className={classNames({
          [classes.map]: true,
          [classes.gmStyle]: showZoomControl
        })}
        onClick={(event: any) => {
          event.stopPropagation();
        }}
      />
    </>
  );
};

export default Map;
